import React, { Component } from "react"
import { Field } from "components/elements"

class MapSwitch extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: this.props.initialSetting
    }
  }

    componentDidMount() { 
        if (this.state.active === true) { 
            document.body.classList.add("map-right-open")
        }
        else {
            document.body.classList.add("map-right-closed")
        }
    }
    
    componentDidUpdate(props, prevProps) {
        if (props.initialSetting !== prevProps.initialSetting) {
        if (props.initialSetting !== this.state.active) {
            this.setState({ active: props.initialSetting })
        }
        }
    }

    componentWillUnmount() {
        document.body.classList.remove("map-right-open")
        document.body.classList.remove("map-right-closed")
    }

    toggleMap = checked => {
        this.setState({ active: checked })
        this.props.onChange(checked)
        if (checked) {
        document.body.classList.remove("map-right-closed")
        document.body.classList.add("map-right-open")
        }

        if (!checked) {
        document.body.classList.add("map-right-closed")
        document.body.classList.remove("map-right-open")
        }
    }

  render() {
    const { active } = this.state

    const { disabled } = this.props

    return (
      <Field
        wrapClassName={this.props.className}
        showErrors={false}
        type="switch"
        label={<i className="fas fa-map"></i>}
        disabled={disabled}
        id="toggle-map"
        name="toggle-map"
        checked={active}
        onChange={({ checked }) => this.toggleMap(checked)}
      />
    )
  }
}
export default MapSwitch

MapSwitch.defaultProps = {
  onChange: function() {},
  initialSetting: true,
  disabled: false,
  className: ''
}
